/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./resolution-filter.vue?vue&type=template&id=806804be&"
import script from "./resolution-filter.vue?vue&type=script&lang=ts&"
export * from "./resolution-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports